import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import WaterMark from "../../Components/WaterMark/WaterMark";

import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

const TanstackTable = ({
  heading = "Table",
  columns = [],
  apiFn,
  queryKey = "tableData",
  filter = {},
  theadColor = "bg-[#2A5775]",
  theadCss = "text-white",
  border = "",
  height = "200px",
}) => {
  const { data, isFetching, isError } = useQuery({
    queryKey: [queryKey, filter],
    queryFn: () => apiFn(filter),
    enabled: Object.keys(filter).length > 0,
    cacheTime: 0,
    staleTime: 0,
  });

  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <div className="text-center text-red-500 p-4">Failed to load data.</div>
    );

  return (
    <div className="relative w-full shadow-lg rounded-md bg-white p-2 h-full">
      <WaterMark />
      <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-2">
        {heading}
      </h2>
      {data && data.length > 0 ? (
        <div className={`overflow-auto  ${height} mt-2 md:mt-0 pr-1 `}>
          <table className={`min-w-full `}>
            {/* <thead className={`sticky top-0 ${theadColor} `}> */}
            <thead
              className={`sticky top-0 ${theadColor} ${theadCss} ${
                theadCss.includes("text-left")
                  ? "[&>tr>th:not(:first-child)]:text-center"
                  : ""
              }`}
            >
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      className={` px-2 py-1  text-sm font-medium  ${theadCss}`}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className={`hover:bg-gray-50  border-b border-gray-300`}
                >
                  {row.getVisibleCells().map((cell) => (
                    // <td
                    //   key={cell.id}
                    //   className="px-2 py-1 text-sm text-gray-700 text-center"
                    // >
                    //   {flexRender(
                    //     cell.column.columnDef.cell,
                    //     cell.getContext()
                    //   )}
                    // </td>
                    <td
                      key={cell.id}
                      className={`px-2 py-1 text-sm text-gray-700 ${
                        theadCss.includes("text-left") &&
                        cell.column.id === table.getAllColumns()[0].id
                          ? "text-left"
                          : "text-center"
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center text-gray-600">No data available</div>
      )}
    </div>
  );
};

export default TanstackTable;
